module.exports = __webpack_public_path__ + "static/img/P2.1fc2545.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mssj/P2.png
// module id = vTuc
// module chunks = 0